/*
 * dm-spin-wheel.js (theme v8)
 * Spin-to-win store credit: wheel popup, header credit chip, credit-page box, cart-drawer credit row.
 *
 * Honest by construction:
 *  - the outcome is one uniformly random slot (crypto.getRandomValues); each slot is equally likely and the wheel shows exactly the slots in #dm-spin-data
 *  - the amount shown is the amount of the discount code that gets applied (fixed-amount order discount, created in Shopify admin)
 *  - the win is saved in localStorage (key dm_spin_v1) for cfg.validHours hours (2); nothing is sent anywhere except the /discount/CODE request
 *  - when the hours run out the credit, the header chip and the wheel are gone for this browser (one spin per browser) and the SPIN code is taken off the cart (cart/update.js) and the discount_code cookie
 * window.DMSpin.creditCents() is read by assets/dm-cart.js for the drawer total.
 */
(function () {
  'use strict';
  var DM = window.DM;
  if (!DM) return;

  var KEY = 'dm_spin_v1';
  var APPLIED_KEY = 'dm_spin_applied';
  var NS = 'http://www.w3.org/2000/svg';
  var dataEl = document.getElementById('dm-spin-data');
  var cfg = {};
  try {
    cfg = dataEl ? JSON.parse(dataEl.textContent) : {};
  } catch (e) {
    cfg = {};
  }
  var SLOTS = cfg.slots && cfg.slots.length ? cfg.slots : [5, 15, 10, 20, 5, 15, 10, 20];
  var CODES = cfg.codes || {};
  var HOURS = cfg.validHours || 2;
  var VALID_MS = HOURS * 3600000;
  var HOURS_TXT = HOURS + (HOURS === 1 ? ' hour' : ' hours');
  var RESHOW_MS = (cfg.reshowDays || 3) * 86400000;
  var DELAY_MS = Math.max(0, (cfg.delay === undefined ? 10 : cfg.delay) * 1000);
  var ROOT = cfg.root || '/';
  var SPIN_MS = 5600;

  var modal = document.getElementById('dm-spin');
  var panel = modal ? modal.querySelector('.dm-spin__panel') : null;
  var chip = document.querySelector('[data-dm-credit-chip]');
  var wheelSvg = null;
  var rotation = 0;
  var spinning = false;
  var yielding = false; // true while the wheel steps aside for the cookie banner (not a real close)

  /* ---------- storage (falls back to memory when the browser blocks it) ---------- */
  var memory = null;
  function readStore() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) || {} : {};
    } catch (e) {
      return {};
    }
  }
  function getState() {
    var fresh = readStore();
    if (fresh && (fresh.at || fresh.closed)) memory = fresh; // another tab may have spun or closed since
    else if (!memory) memory = fresh;
    return memory;
  }
  function setState(next) {
    memory = next;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      /* private mode: this tab still works from memory */
    }
  }
  function canPersist() {
    try {
      var k = KEY + '_t';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }
  function validSpin() {
    var st = getState();
    if (st && st.amount > 0 && st.code && st.at && Date.now() - st.at < VALID_MS) return st;
    return null;
  }
  // true once this browser has spun, also after the win ran out (one spin per browser)
  function hasSpun() {
    var st = getState();
    return !!(st && st.amount > 0 && st.at);
  }
  function msLeft() {
    var st = validSpin();
    return st ? Math.max(0, st.at + VALID_MS - Date.now()) : 0;
  }
  function clock(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor((s % 3600) / 60);
    var x = s % 60;
    return Math.floor(s / 3600) + ':' + (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x;
  }
  function leftShort(ms) {
    var m = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(m / 60);
    m = m % 60;
    return h > 0 ? h + 'h' + (m ? ' ' + m + 'm' : '') : m + 'm';
  }
  function clockTime(ts) {
    try {
      return new Date(ts).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    } catch (e) {
      return '';
    }
  }
  function dollars(cents) {
    return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
  }
  function accountCents() {
    return chip ? parseInt(chip.getAttribute('data-account-cents'), 10) || 0 : 0;
  }
  function creditCents() {
    var s = validSpin();
    return s ? s.amount * 100 : 0;
  }

  /* ---------- randomness ---------- */
  function randInt(n) {
    var c = window.crypto || window.msCrypto;
    if (c && c.getRandomValues) {
      var buf = new Uint32Array(1);
      var max = Math.floor(4294967296 / n) * n;
      do {
        c.getRandomValues(buf);
      } while (buf[0] >= max);
      return buf[0] % n;
    }
    return Math.floor(Math.random() * n);
  }
  function rand01() {
    return randInt(1000000) / 1000000;
  }

  /* ---------- discount code ---------- */
  function applyCode(code) {
    if (!code || !window.fetch) return Promise.resolve(false);
    return window
      .fetch(ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'robots.txt'), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }
  function ensureApplied() {
    var s = validSpin();
    if (!s) return;
    var done = false;
    try {
      done = window.sessionStorage.getItem(APPLIED_KEY) === s.code;
    } catch (e) {}
    if (done) return;
    applyCode(s.code).then(function (ok) {
      if (!ok) return;
      try {
        window.sessionStorage.setItem(APPLIED_KEY, s.code);
      } catch (e) {}
    });
  }

  /* ---------- expiry: the win lasts HOURS hours ---------- */
  var SPIN_RE = /^SPIN\d+-/i;
  var stripping = null;
  var tickTimer = null;
  var lastChipKey = '';
  function needsStrip() {
    var st = getState();
    return !!(st && st.amount > 0 && st.at && Date.now() - st.at >= VALID_MS && !st.stripped);
  }
  // Take the SPIN code off the visitor's cart and drop the discount_code cookie that /discount/CODE set.
  // Resolves true (removed), false (nothing to remove) or null (could not check: try again later).
  function stripDiscount() {
    try {
      var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
      if (m && SPIN_RE.test(decodeURIComponent(m[1]))) document.cookie = 'discount_code=; Max-Age=0; path=/';
    } catch (e) {}
    try {
      window.sessionStorage.removeItem(APPLIED_KEY);
    } catch (e) {}
    if (!window.fetch) return Promise.resolve(null);
    return window
      .fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var apps = cart.cart_level_discount_applications || [];
        var ours = apps.some(function (a) {
          return SPIN_RE.test(a.title || '');
        });
        if (!ours) return false;
        var keep = apps
          .filter(function (a) {
            return a.type === 'discount_code' && !SPIN_RE.test(a.title || '');
          })
          .map(function (a) {
            return a.title;
          });
        return window
          .fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: keep.join(',') })
          })
          .then(function (r) {
            if (!r.ok) throw new Error('update');
            return true;
          });
      })
      .catch(function () {
        return null;
      });
  }
  function expire() {
    var st = getState();
    if (!st || !(st.amount > 0) || !st.at || Date.now() - st.at < VALID_MS) return Promise.resolve(false);
    if (tickTimer) {
      window.clearInterval(tickTimer);
      tickTimer = null;
    }
    if (modal && DM.modal && !spinning && DM.modal.isOpen(modal)) DM.modal.close(modal, { instant: true, restoreFocus: false });
    renderChip();
    renderBox();
    if (st.stripped) return Promise.resolve(false);
    if (stripping) return stripping;
    stripping = stripDiscount().then(function (res) {
      stripping = null;
      if (res === null) return false; // offline: the next check tries again
      var cur = getState() || st;
      setState({ v: 1, amount: cur.amount, at: cur.at, idx: cur.idx, rot: cur.rot, expired: Date.now(), stripped: Date.now() }); // code dropped
      if (res && window.DMCart && window.DMCart.refresh) window.DMCart.refresh().catch(function () {});
      document.dispatchEvent(new CustomEvent('dm:spin:change'));
      return res;
    });
    return stripping;
  }
  function tick() {
    if (!validSpin()) {
      expire();
      return;
    }
    var left = msLeft();
    DM.$$('[data-dm-spin-left],[data-dm-sc-left]').forEach(function (n) {
      n.textContent = clock(left);
    });
    var key = leftShort(left);
    if (key !== lastChipKey) {
      lastChipKey = key;
      renderChip();
    }
  }
  function startTicker() {
    if (tickTimer || !validSpin()) return;
    tickTimer = window.setInterval(tick, 1000);
    tick();
  }
  function recheck() {
    if (validSpin()) startTicker();
    else if (needsStrip()) expire();
  }

  /* ---------- wheel drawing ---------- */
  function svgEl(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function polar(c, r, deg) {
    var a = (deg * Math.PI) / 180;
    return [c + r * Math.cos(a), c + r * Math.sin(a)];
  }
  function buildWheel() {
    var host = modal && modal.querySelector('[data-dm-spin-wheel]');
    if (!host || wheelSvg) return;
    var n = SLOTS.length;
    var step = 360 / n;
    var C = 150;
    var R = 134;
    var svg = svgEl('svg', { viewBox: '0 0 300 300', class: 'dm-spin__wheel', 'aria-hidden': 'true', focusable: 'false' });
    var defs = svgEl('defs', {}, svg);
    var g = svgEl('linearGradient', { id: 'dm-spin-rim', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
    svgEl('stop', { offset: '0', 'stop-color': '#EEF1F4' }, g);
    svgEl('stop', { offset: '0.5', 'stop-color': '#AEB6C0' }, g);
    svgEl('stop', { offset: '1', 'stop-color': '#E2E6EB' }, g);
    svgEl('circle', { cx: C, cy: C, r: R + 14, fill: 'url(#dm-spin-rim)' }, svg);
    svgEl('circle', { cx: C, cy: C, r: R + 1.5, fill: '#fff' }, svg);
    var i;
    for (i = 0; i < n; i++) {
      var p0 = polar(C, R, i * step - step / 2);
      var p1 = polar(C, R, i * step + step / 2);
      svgEl(
        'path',
        {
          d: 'M' + C + ' ' + C + 'L' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) + 'A' + R + ' ' + R + ' 0 0 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) + 'Z',
          fill: i % 2 ? '#F98B4E' : '#FFF1E0',
          stroke: '#fff',
          'stroke-width': '1.5'
        },
        svg
      );
    }
    for (i = 0; i < n; i++) {
      var t = svgEl(
        'text',
        {
          x: C + R - 16,
          y: C,
          dy: '0.35em',
          transform: 'rotate(' + i * step + ' ' + C + ' ' + C + ')',
          'text-anchor': 'end',
          'font-size': '30',
          'font-weight': '800',
          fill: '#07162A',
          'font-family': "'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif"
        },
        svg
      );
      t.textContent = '$' + SLOTS[i];
    }
    for (i = 0; i < n; i++) {
      var pg = polar(C, R + 7.5, i * step + step / 2);
      svgEl('circle', { cx: pg[0].toFixed(2), cy: pg[1].toFixed(2), r: 3.4, fill: '#fff', stroke: '#8E97A2', 'stroke-width': '0.8' }, svg);
    }
    host.appendChild(svg);
    wheelSvg = svg;
  }
  function setRotation(deg, instant) {
    if (!wheelSvg) return;
    if (instant) wheelSvg.classList.add('is-instant');
    wheelSvg.style.transform = 'rotate(' + deg + 'deg)';
    rotation = deg;
    if (instant) {
      void wheelSvg.getBoundingClientRect();
      wheelSvg.classList.remove('is-instant');
    }
  }

  /* ---------- views ---------- */
  function setView(name) {
    if (!panel) return;
    panel.setAttribute('data-state', name);
    DM.$$('[data-when]', panel).forEach(function (node) {
      node.hidden = node.getAttribute('data-when').split(' ').indexOf(name) < 0;
    });
  }
  function fillWon(st) {
    var amt = modal.querySelector('[data-dm-spin-amount]');
    var code = modal.querySelector('[data-dm-spin-code]');
    if (amt) amt.textContent = '$' + st.amount;
    if (code) code.textContent = st.code;
    var copy = modal.querySelector('[data-dm-spin-copy]');
    if (copy) copy.textContent = 'Copy';
    var left = modal.querySelector('[data-dm-spin-left]');
    if (left) left.textContent = clock(msLeft() || VALID_MS);
  }
  function showIdle() {
    setView('idle');
    var go = modal.querySelector('[data-dm-spin-go]');
    if (go) {
      go.disabled = false;
      go.textContent = 'Click to spin';
    }
  }
  function showWon(st, instant) {
    fillWon(st);
    if (typeof st.rot === 'number') setRotation(st.rot + 360 * 2, !!instant);
    setView('won');
  }

  /* ---------- the spin ---------- */
  function spin() {
    if (spinning || !wheelSvg) return;
    var existing = validSpin();
    if (existing) {
      showWon(existing, true);
      return;
    }
    if (hasSpun()) return; // the win ran out: one spin per browser
    spinning = true;
    var n = SLOTS.length;
    var step = 360 / n;
    var idx = randInt(n);
    var amount = SLOTS[idx];
    var code = CODES[String(amount)];
    if (!code) {
      spinning = false;
      return;
    }
    var reduce = DM.reducedMotion && DM.reducedMotion();
    var jitter = (rand01() - 0.5) * step * 0.4; /* +-9 degrees: natural stop, always clearly inside the slot the pointer shows */
    var turns = reduce ? 1 : 5;
    var target = Math.ceil(rotation / 360) * 360 + 360 * turns + (360 - idx * step) + jitter;
    var rotMod = ((target % 360) + 360) % 360;
    /* The outcome is decided and saved at the click, so reloading mid-spin cannot re-roll it. */
    var st = { v: 1, amount: amount, code: code, at: Date.now(), idx: idx, rot: rotMod };
    setState(st);
    applyCode(code).then(function (ok) {
      var warn = modal.querySelector('[data-dm-spin-warn]');
      if (warn) warn.hidden = !!ok;
      if (ok) {
        try {
          window.sessionStorage.setItem(APPLIED_KEY, code);
        } catch (e) {}
      }
    });
    setView('spinning');
    var go = modal.querySelector('[data-dm-spin-go]');
    if (go) {
      go.disabled = true;
      go.textContent = 'Spinning…';
    }
    var dur = reduce ? 900 : SPIN_MS;
    wheelSvg.style.transitionDuration = dur + 'ms';
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      wheelSvg.removeEventListener('transitionend', onEnd);
      wheelSvg.style.transitionDuration = '';
      spinning = false;
      fillWon(st);
      setView('won');
      renderChip();
      renderBox();
      startTicker();
      document.dispatchEvent(new CustomEvent('dm:spin:change'));
      if (DM.announce) DM.announce('You won $' + amount + ' store credit. It is applied to your order at checkout and held for ' + HOURS_TXT + '.');
      var keep = modal.querySelector('[data-dm-spin-keep]');
      if (keep) keep.focus();
    };
    var onEnd = function (e) {
      if (e.target === wheelSvg && e.propertyName === 'transform') finish();
    };
    wheelSvg.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, dur + 500);
    setRotation(target, false);
  }

  /* ---------- open / auto-open ---------- */
  function openWheel(opener) {
    if (!modal || !DM.modal) return;
    if (hasSpun() && !validSpin() && !modal.hasAttribute('data-force')) return; // the win ran out: the wheel does not come back
    buildWheel();
    var s = validSpin();
    if (s && !spinning) showWon(s, true);
    else if (!spinning) {
      setRotation(0, true);
      showIdle();
    }
    DM.modal.open(modal, opener);
    if (s && !spinning) {
      var keep = modal.querySelector('[data-dm-spin-keep]');
      if (keep) keep.focus();
    }
  }
  function cookieBannerUp() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && (b.offsetWidth || b.offsetHeight));
  }
  // Shopify's privacy-banner.js adds #shopify-pc__banner a few hundred ms to ~2 s after load, only for visitors who have not answered it yet
  // (the answer lives in an HttpOnly cookie we cannot read, so we remember in localStorage that this browser has been shown the banner).
  // While the banner is still about to appear, hold the wheel back so the two popups never flash over each other.
  var PC_KEY = 'dm_spin_pc_seen';
  function pcSeen() {
    try { return window.localStorage.getItem(PC_KEY) === '1'; } catch (e) { return false; }
  }
  function pcMark() {
    try { window.localStorage.setItem(PC_KEY, '1'); } catch (e) { /* ignore */ }
  }
  function bannerPending() {
    if (document.getElementById('shopify-pc__banner')) return false; // already there: cookieBannerUp() handles it
    if (!document.querySelector('script[src*="privacy-banner"]')) return false;
    if (pcSeen()) return false; // shown (and answered) on an earlier visit
    return (window.performance && performance.now ? performance.now() : 0) < 2500;
  }
  function autoOpen() {
    if (!modal || !DM.modal) return;
    var force = modal.hasAttribute('data-force') || /[?&]spin=1(&|$)/.test(window.location.search);
    var body = document.body;
    if (!force) {
      if (body.classList.contains('dm-template-cart') || body.classList.contains('dm-template-password')) return;
      if (cfg.loggedIn) return;
      if (/\/pages\/store-credit/.test(window.location.pathname)) return;
      if (!canPersist()) return;
      if (hasSpun()) return; // a live win keeps the wheel closed, an ended one never brings it back
      var st = getState();
      if (st && st.closed && Date.now() - st.closed < RESHOW_MS) return;
    }
    var tries = 0;
    var POLL_MS = 300; // check often so the wheel appears right after a cookie banner or another popup is answered
    var attempt = function () {
      if (cookieBannerUp()) pcMark();
      if (DM.modal.top() || cookieBannerUp() || bannerPending()) {
        if (tries++ < 400) window.setTimeout(attempt, POLL_MS);
        return;
      }
      openWheel(null);
      // If the banner still lands on top of the wheel (slow network), step aside (not counted as "closed")
      // and come back as soon as the banner is answered.
      var watched = 0;
      var guard = function () {
        if (spinning || !DM.modal.isOpen(modal)) return;
        if (cookieBannerUp()) {
          pcMark();
          yielding = true;
          DM.modal.close(modal, { instant: true, restoreFocus: false });
          yielding = false;
          tries = 0;
          window.setTimeout(attempt, POLL_MS);
          return;
        }
        if (watched++ < 60) window.setTimeout(guard, 100);
      };
      window.setTimeout(guard, 100);
    };
    window.setTimeout(attempt, force ? 600 : DELAY_MS);
  }

  /* ---------- header chip ---------- */
  function renderChip() {
    if (!chip) return;
    var spinCents = creditCents();
    var total = spinCents + accountCents();
    var long = chip.querySelector('[data-dm-credit-long]');
    var short = chip.querySelector('[data-dm-credit-short]');
    chip.style.display = total === 0 && hasSpun() ? 'none' : ''; // win ran out: the chip goes away
    if (total > 0) {
      chip.classList.add('has-credit');
      var left = spinCents > 0 ? leftShort(msLeft()) + ' left' : '';
      if (long) long.textContent = 'Store credit ' + dollars(total) + (left ? ' \u00b7 ' + left : '');
      if (short) short.textContent = dollars(total);
      chip.setAttribute('aria-label', 'Your store credit: ' + dollars(total) + (left ? ', the spin part has ' + left : '') + '. See how it works.');
    } else {
      chip.classList.remove('has-credit');
      if (long) long.textContent = 'Spin to win';
      if (short) short.textContent = 'Spin';
      chip.setAttribute('aria-label', 'Spin to win up to $20 store credit');
    }
  }

  /* ---------- credit page box ---------- */
  function renderBox() {
    var host = document.querySelector('[data-dm-sc-you]');
    if (!host) return;
    while (host.firstChild) host.removeChild(host.firstChild);
    function node(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }
    var card = node('div', 'dm-sc-you__card');
    card.appendChild(node('p', 'dm-sc-you__h', 'Your store credit'));
    var list = node('ul', 'dm-sc-you__rows');
    var s = validSpin();
    var li = node('li', 'dm-sc-you__row');
    li.appendChild(node('span', 'dm-sc-you__k', 'Spin credit'));
    li.appendChild(node('b', 'dm-sc-you__v', s ? '$' + s.amount : '$0'));
    var small = node('small', 'dm-sc-you__n');
    if (s) {
      small.appendChild(document.createTextNode('Comes off your order at checkout. Time left '));
      var tl = node('b', '', clock(msLeft()));
      tl.setAttribute('data-dm-sc-left', '');
      small.appendChild(tl);
      small.appendChild(document.createTextNode(' (until ' + clockTime(s.at + VALID_MS) + ').'));
    } else if (hasSpun()) {
      small.textContent = 'Your spin credit has ended. It is held for ' + HOURS_TXT + ' after you spin, and each customer gets one spin.';
    } else {
      small.textContent = 'Spin the wheel for $5, $10, $15 or $20 off your order. The win is held for ' + HOURS_TXT + '.';
    }
    li.appendChild(small);
    list.appendChild(li);
    if (cfg.loggedIn) {
      var a = node('li', 'dm-sc-you__row');
      a.appendChild(node('span', 'dm-sc-you__k', 'On your account'));
      a.appendChild(node('b', 'dm-sc-you__v', dollars(accountCents())));
      a.appendChild(node('small', 'dm-sc-you__n', 'Earned from past orders. At checkout, choose “Apply store credit”.'));
      list.appendChild(a);
    }
    card.appendChild(list);
    if (!s && !hasSpun()) {
      var btn = node('button', 'dm-spin__go dm-sc-you__spin', 'Spin the wheel');
      btn.type = 'button';
      btn.setAttribute('data-dm-spin-open', '');
      card.appendChild(btn);
    }
    host.appendChild(card);
  }

  /* ---------- wiring ---------- */
  function init() {
    renderChip();
    renderBox();
    if (needsStrip()) expire();
    else {
      ensureApplied();
      startTicker();
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) recheck();
    });
    window.addEventListener('pageshow', recheck);
    window.addEventListener('focus', recheck);
    window.addEventListener('storage', function (e) {
      if (e.key !== KEY) return;
      renderChip();
      renderBox();
      recheck();
    });

    // Checkout must never start with an ended win still on the cart: hold the click until it is taken off, then repeat it.
    var passing = false;
    document.addEventListener(
      'click',
      function (event) {
        if (passing) return;
        var t = event.target instanceof Element ? event.target : null;
        var go = t ? t.closest('a[href*="/checkout"], [name="checkout"]') : null;
        if (!go || !(needsStrip() || stripping)) return;
        event.preventDefault();
        event.stopPropagation();
        (stripping || expire()).then(function () {
          passing = true;
          try {
            go.click();
          } finally {
            passing = false;
          }
        });
      },
      true
    );

    document.addEventListener('click', function (event) {
      var t = event.target instanceof Element ? event.target : null;
      if (!t) return;
      var opener = t.closest('[data-dm-spin-open]');
      if (opener) {
        event.preventDefault();
        openWheel(opener);
        return;
      }
      var c = t.closest('[data-dm-credit-chip]');
      if (c && creditCents() + accountCents() === 0 && modal) {
        event.preventDefault();
        openWheel(c);
      }
    });

    if (!modal) return;
    buildWheel();
    var go = modal.querySelector('[data-dm-spin-go]');
    if (go) go.addEventListener('click', spin);
    var copy = modal.querySelector('[data-dm-spin-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var s = validSpin();
        if (!s) return;
        var done = function () {
          copy.textContent = 'Copied';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(s.code).then(done, done);
        else done();
      });
    }
    modal.addEventListener('dm:modal:close', function () {
      if (spinning || yielding) return;
      if (!hasSpun()) setState({ closed: Date.now() });
      else renderChip();
    });
    autoOpen();
  }

  window.DMSpin = { creditCents: creditCents, open: openWheel, state: validSpin };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
